module.exports = __webpack_public_path__ + "assets/img/mt-logo.51974816.png";